import axios from "axios";
import { getUrl } from "@/common/config";
import BaseApi from "./baseApi";
// import fakeMP from "@/api/json/fake/machineProductions";
// import fakeMPD from "@/api/json/fake/machineProductionDetails";

export default class MachineProductionsApi {
  constructor() {
    this.url = getUrl();
  }

  /*
   * Search params:
   * @param: skip
   * @param: limit
   * @param: from, String date
   * @param: to, String date
   *
   */
  getMachineProductions(machineId, search, getAll) {
    // return new Promise((resolve, reject) => {
    //  resolve(fakeMP)
    //})
    const url = this.url;
    const cbk = filter => {
      return axios
        .get(`${url}/api/v2/machines/${machineId}/productions`, { params: filter })
        .then(response => response.data);
    };

    if (!getAll) {
      return cbk(search);
    } else {
      const baseApi = new BaseApi();
      return baseApi.getAll(cbk, search);
    }
  }

  /*
   * Search params:
   * @param: from, String date
   * @param: to, String date
   *
   */
  getMachineProductionDetails(machineId, productionId, search) {
    // return new Promise((resolve, reject) => {
    //   resolve(fakeMPD)
    // })
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/productions/${productionId}`, {
        params: search
      })
      .then(response => response.data);
  }
}
